import React, { useCallback, useRef, useState } from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';

import classes from './styles.module.scss';

const Draggable = (props) => {
    const { onPointerDown, onPointerUp, onPointerMove, onDragMove, children, className, ...restProps } = props;

    const [isDragging, setIsDragging] = useState(false);
    const [newPosition, setNewPosition] = useState({
        x: 0,
        y: 0,
    });

    const draggableRef = useRef(null);
    const previousPosition = useRef({});

    const handlePointerDown = useCallback(
        (event) => {
            setIsDragging(true);
            previousPosition.current.x = (event?.touches ? event.touches[0] : event).clientX;
            previousPosition.current.y = (event?.touches ? event.touches[0] : event).clientY;
            onPointerDown(event);
        },
        [onPointerDown]
    );

    const handlePointerUp = useCallback(
        (event) => {
            setIsDragging(false);
            onPointerUp(event);
        },
        [onPointerUp]
    );

    const handlePointerLeave = useCallback(
        (event) => {
            setIsDragging(false);
            onPointerUp(event);
        },
        [onPointerUp]
    );

    const handlePointerMove = useCallback(
        (event) => {
            if (isDragging) {
                setNewPosition({
                    x: previousPosition.current.x - (event?.touches ? event.touches[0] : event).clientX,
                    y: previousPosition.current.y - (event?.touches ? event.touches[0] : event).clientY,
                });
                previousPosition.current.x = (event?.touches ? event.touches[0] : event).clientX;
                previousPosition.current.y = (event?.touches ? event.touches[0] : event).clientY;

                let top = draggableRef.current.offsetTop - newPosition.y;
                if (draggableRef.current.offsetTop < 0) {
                    top = 0;
                } else if (draggableRef.current.offsetTop > document.body.clientHeight - draggableRef.current.clientHeight) {
                    top = document.body.clientHeight - draggableRef.current.clientHeight;
                }

                let left = draggableRef.current.offsetLeft - newPosition.x;
                if (draggableRef.current.offsetLeft < 0) {
                    left = 0;
                } else if (draggableRef.current.offsetLeft > document.body.clientWidth - draggableRef.current.clientWidth) {
                    left = document.body.clientWidth - draggableRef.current.clientWidth;
                }

                draggableRef.current.style.top = `${top}px`;
                draggableRef.current.style.left = `${left}px`;
                draggableRef.current.style.bottom = 'initial';
                draggableRef.current.style.right = 'initial';

                onDragMove(event);
            }
            onPointerMove(event);
        },
        [newPosition.y, newPosition.x, isDragging, onDragMove, onPointerMove]
    );

    return (
        <div
            ref={draggableRef}
            onMouseDown={handlePointerDown}
            onMouseUp={handlePointerUp}
            onMouseLeave={handlePointerLeave}
            onMouseMove={handlePointerMove}
            onTouchStart={handlePointerDown}
            onTouchEnd={handlePointerUp}
            onTouchMove={handlePointerMove}
            className={clsx(classes.root, className)}
            {...restProps}
        >
            {children}
        </div>
    );
};

Draggable.defaultProps = {
    children: '',
    className: '',
    onPointerDown: () => {},
    onPointerUp: () => {},
    onPointerMove: () => {},
    onDragMove: () => {},
};

Draggable.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onPointerDown: PropTypes.func,
    onPointerUp: PropTypes.func,
    onPointerMove: PropTypes.func,
    onDragMove: PropTypes.func,
};
export default Draggable;
